<template>
  <b-modal id="customFieldValueAddModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.customField.create.header') }} ({{ parentTitle }})</h6>
      </b-col>
    </b-row>
    <b-row v-if="routeName === 'EXCMCaseTypeCreate' || routeName === 'EXCMTaskTypeCreate'">
      <b-col>
        <div v-if="error" class="alert alert-danger" role="alert">
          <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ error }}
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <CustomFieldValueForm :item="item"></CustomFieldValueForm>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="float-right">
          <button type="submit" class="btn btn-success" @click="storeObject()">{{$t('buttons.save')}}</button>
          <b-button class="btn btn-secondary" @click="closeModal()">{{ closeText }}</b-button>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import CustomFieldValueForm from '../CustomFieldValueForm'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('excmcustomfieldvalue/create')
export default {
  name: 'CustomFieldValueAddModal',
  components: {
    CustomFieldValueForm
  },
  data () {
    return {
      routeName: '',
      closeText: this.$t('buttons.close'),
      parentTitle: '',
      valueParent: {},
      item: {
        value: '',
        defaultValue: 0
      }
    }
  },
  created () {
    this.routeName = this.$route.name
  },
  computed: {
    ...mapGetters([
      'error',
      'isLoading',
      'created',
      'violations'
    ]),
    show () {
      return this.$store.state.modals.customFieldValue.create.show
    },
    parent () {
      return this.$store.state.modals.customFieldValue.create.parent
    }
  },
  watch: {
    show: function (val) {
      this.openModal()
    },
    parent: function (val) {
      this.openModal()
    }
  },
  methods: {
    ...mapActions([
      'create'
    ]),
    openModal () {
      if (this.show === 1 && Object.entries(this.parent).length > 0) {
        this.valueParent = this.$store.state.modals.customFieldValue.create.parent
        this.parentTitle = this.valueParent['name']
        this.$store.state.modals.customFieldValue.create.show = 0
        this.$store.state.modals.customFieldValue.create.parent = {}
        this.$bvModal.show('customFieldValueAddModal')
      }
    },
    closeModal () {
      this.$bvModal.hide('customFieldValueAddModal')
    },
    resetData () {
      this.item = {
        value: '',
        defaultValue: 0
      }
      this.valueParent = {}
    },
    storeObject () {
      if (this.routeName === 'EXCMCaseTypeCreate' || this.routeName === 'EXCMTaskTypeCreate') {
        this.appendToParent()
      } else if (this.routeName === 'EXCMCaseTypeShow' || this.routeName === 'EXCMTaskTypeShow') {
        this.appendToParent()
      } else if (this.routeName === 'EXCMCaseTypeUpdate' || this.routeName === 'EXCMTaskTypeUpdate') {
        this.appendToParent()
      }
    },
    validateData () {
      this.error = ''
      if (this.item.value === '') {
        this.error += this.$t('error.valueFieldNotEmpty')
      }
    },
    appendToParent () {
      this.validateData()
      if (this.error.length === 0) {
        let item = Object.assign({}, this.item)
        if ('@id' in this.valueParent) {
          item.customField = this.valueParent['@id']
        }
        this.$store.state.modals.customFieldValue.create.customFieldValueObject = item
        this.closeModal()
      }
    },
    appendToDB () {
      let item = Object.assign({}, this.item)
      item.customField = this.valueParent['@id']
      this.create(item)
    }
  }
}
</script>
